import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { filter, takeUntil } from "rxjs/operators";
import { Observable, Subject } from "rxjs";
import { UserInfo } from "app/shared/models/user-info.interface";
import { AuthService } from "app/core/auth/service/auth.service";
import { AvatarComponent } from "app/shared/components/avatar/avatar.component";
import { AsyncPipe, NgIf } from "@angular/common";
import { VerticalDividerComponent } from "app/shared/components/vertical-divider/vertical-divider.component";

@Component({
  selector: "user-info",
  templateUrl: "./user-info.component.html",
  styleUrls: ["./user-info.component.scss"],
  imports: [AvatarComponent, AsyncPipe, VerticalDividerComponent, NgIf],
})
export class UserInfoComponent implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  @Input() public isAdmin: boolean = false;
  @Output() public isUserSettingsShown: EventEmitter<boolean> =
    new EventEmitter<boolean>(true);
  public userName: string = "";
  public userInfo$: Observable<UserInfo> = this.authService.userInfo$;

  constructor(private authService: AuthService) {}

  public ngOnInit(): void {
    this.initUser();
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private initUser(): void {
    this.authService.userInfo$
      .pipe(
        filter((userInfo: UserInfo) => !!userInfo),
        takeUntil(this.ngUnsubscribe),
      )
      .subscribe((userInfo: UserInfo) => {
        this.userName = userInfo?.user
          ? `${userInfo.user.firstname} ${userInfo.user.lastname}`
          : "";
      });
  }
}
